// src/lib/supabaseClient.ts
import { createClient } from '@supabase/supabase-js'
import { supabaseAnonKey, supabaseUrl } from './supabaseConfig';

export const supabase = createClient(supabaseUrl!, supabaseAnonKey!);

export const createNoStoreSupabase = () => createClient(supabaseUrl!, supabaseAnonKey!, {
  global: {
    fetch: (input, init) => fetch(input, { ...init, cache: 'no-store' }),
  },
});
